<template>
  <Head :title="__('payout.payout-options.charity.title')" />

  <Breadcrumbs
    :pages="[
      { name: __('balance.title'), href: route('frontend.balance') },
      { name: __('payout.overview.title'), href: route('frontend.payout') },
    ]"
    :current-page="__('payout.payout-options.charity.title')"
  />

  <section class="mb-6 md:mb-12">
    <div class="container">
      <div class="flex flex-col lg:flex-row">
        <div class="flex flex-col lg:w-4/12 lg:mr-8">
          <h1 class="text-2xl md:text-3xl font-bold mb-4 md:mb-2.5">
            {{ __('payout.payout-options.charity.title') }}
          </h1>
          <div class="hidden lg:flex flex-col">
            <img
              class="inline w-1/2 opacity-10"
              src="/qassa/images/payout-charity.svg"
            >
          </div>
        </div>

        <div class="md:bg-white md:shadow rounded w-full lg:w-8/12 md:p-6">
          <form
            @submit.prevent="form.post(route('frontend.payout.charity.store'))"
          >
            <div class="flex flex-col space-y-4">
              <div class="flex flex-col md:flex-row md:items-center">
                <label>
                  {{ __('payout.payout-options.charity.minimum', {minimum: minimumPayoutValue}) }}
                </label>
                <div class="md:w-2/3">
                  <select v-model="form.value">
                    <option
                      disabled
                      :value="null"
                    >
                      - {{ __('payout.payout-options.charity.make_choice') }} -
                    </option>
                    <option
                      v-for="(label, value) in payoutOptions"
                      :key="`payout-${value}`"
                      :value="value"
                    >
                      {{ label }}
                    </option>
                  </select>
                  <p
                    v-if="form.errors.value"
                    class="text-orange text-xs italic mt-0.5"
                  >
                    {{ form.errors.value }}
                  </p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row md:items-center">
                <label>
                  {{ __('payout.payout-options.charity.charity') }}
                </label>
                <div class="md:w-2/3">
                  <select
                    v-model="form.charity"
                    :required="true"
                  >
                    <option
                      disabled
                      :value="null"
                    >
                      {{ __('payout.payout-options.charity.make_choice') }}
                    </option>
                    <option
                      v-for="charity in charities"
                      :key="`charity-${charity.id}`"
                      :value="charity.id"
                    >
                      {{ charity.name }}
                    </option>
                  </select>
                  <p
                    v-if="form.errors.charity"
                    class="text-orange text-xs italic mt-0.5"
                  >
                    {{ form.errors.charity }}
                  </p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row md:items-center">
                <label>
                  {{ __('general.password_account') }}:
                </label>
                <Password v-model="form.password">
                  <template #errors>
                    <p
                      v-if="form.errors.password"
                      class="text-orange text-xs italic mt-0.5"
                    >
                      {{ form.errors.password }}
                    </p>
                  </template>
                </Password>
              </div>

              <div class="flex justify-end">
                <div class="w-full md:w-auto">
                  <Blue
                    :disabled="form.processing"
                  >
                    {{ __('payout.payout-options.charity.button') }}
                  </Blue>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {useForm} from '@inertiajs/vue3';
import Breadcrumbs from '../../Components/Breadcrumbs.vue';
import Blue from '../../Components/Buttons/Blue.vue';
import Password from '../../Components/Form/Password.vue';

export default {
  components: {
    Breadcrumbs,
    Blue,
    Password,
  },

  props: {
    member: {
      type: Object,
      required: true,
    },

    minimumPayoutValue: {
      type: String,
      required: true,
    },

    payoutOptions: {
      type: Object,
      required: true,
    },

    charities: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const form = useForm({
      value: null,
      charity: null,
      password: null,
    });

    return {
      form,
    };
  },
};
</script>
